import { ApiClient } from '~/clients/ApiClient'

export const useApi = () => {
  const runtimeConfig = useRuntimeConfig()
  const { correlationId } = useAuthStore()
  const fakeHeader = runtimeConfig.public.FAKE_HEADER
  const headers = {
    ...(fakeHeader ? { 'x-ms-client-principal': fakeHeader } : {}),
    'X-Correlation-ID': correlationId ?? '',
  }

  return new ApiClient(runtimeConfig.public.API_BASE_URL, headers)
}
